import { ConfigurationSampleTypeLaboratoryResponse } from '@/modules/configurationModule/detail/local-samples/local-sample-types/services/local-sample-types.dto'
import { Nullable } from '@/shared/types/app.types'
import { WorkflowTypeEnum } from '@/api/services/common/sample-type/common-sample-type.dto'

export interface LocalSampleTypesModalComboElement {
    id: number
    text: string
}

export interface LocalSampleTypesModalCombo {
    list: LocalSampleTypesModalComboElement[]
    selected: Nullable<LocalSampleTypesModalComboElement>
}

export interface LocalSampleTypesModalState {
    selectedRow: ConfigurationSampleTypeLaboratoryResponse
    globalSampleTypes: LocalSampleTypesModalCombo
}
export const initialLocalSampleTypesModalState =
    (): LocalSampleTypesModalState => ({
        selectedRow: {
            active: true,
            defaultDaysBeforeDisposal: 0,
            id: 0,
            laboratory: {
                labActive: false,
                labExternalId: '0',
                labId: 0,
                labName: ''
            },
            processingRequired: true,
            sampleType: {
                active: false,
                code: '',
                description: '',
                id: 0,
                workflow: WorkflowTypeEnum.GROSSING_BIOPSIES
            }
        },
        globalSampleTypes: {
            list: [],
            selected: null
        }
    })
